
import SectionGalleryV1 from './gallery/SectionGalleryV1'
import SectionGalleryV2 from './gallery/SectionGalleryV2'
export default {
  name: 'SectionGallery',
  components: {},
  props: {
    variant: {
      required: true,
      type: String,
      default: ''
    },
    data: {
      required: true,
      type: Object,
      default: function () {
        return {}
      }
    },
    orderNo: {
      required: true,
      type: Number,
      default: 0
    },
    hash: {
      required: true,
      type: String,
      default: ''
    }
  },
  data() {
    return {
      componentVariant: null
    }
  },
  watch: {
    variant: function (newVariant, oldVariant) {
      this.handleVariant(newVariant)
    }
  },
  created() {
    this.handleVariant(this.variant)
  },
  methods: {
    handleVariant(variant) {
      switch (variant) {
        case 'v2':
          this.componentVariant = SectionGalleryV2
          break
        default:
          this.componentVariant = SectionGalleryV1
          break
      }
    }
  }
}
